( function( $ ) {
    'use strict';
    $(window).on('load', function() {
       
        if ($("#wpcf7-f911187-p801333-o1").length) {
			 var wpcf7Elm = document.querySelector( '.wpcf7' );
			wpcf7Elm.addEventListener( 'wpcf7submit', function( event ) {
				var errorSpan  = '<span class="wpcf7-not-valid-tip" aria-hidden="true">The field is required.</span>';
				
				if ( "BusinessType" == event.detail.inputs[6].name && "" == event.detail.inputs[6].value) {
					$(errorSpan).insertAfter('select[name="BusinessType"]');
				}
				
				if ( "Job-Level-Seniority" == event.detail.inputs[7].name && "" == event.detail.inputs[7].value) {
					$(errorSpan).insertAfter('select[name="Job-Level-Seniority"]');
				} 
				
				if ( "Job-Function" == event.detail.inputs[8].name && "" == event.detail.inputs[8].value) {
					$(errorSpan).insertAfter('select[name="Job-Function"]');
				}
			}, false );

			 
			$('.wpcf7-submit').on('click', function (e) {
				
				$(".wpcf7-form-control").each(function(){
					console.log($(this).val());
					 if($(this).val() !== ""){
						$(this).next().find("wpcf7-not-valid-tip").remove();
					 }
				});
				
				if($('select[name="recipient"]').val() != "" && $('input[name="first_name"]').val() != "" && $('input[name="last_name"]').val() != "" && $('input[name="email"]').val() != "" && $('input[name="company"]').val() != "" && $('input[name="title"]').val() != "" && $('textarea[name="message"]').val() != ""){
					var businessType = $('select[name="BusinessType"]').val();
					if (businessType === '') {
						e.preventDefault();
					}
					var jobLevelSeniority = $('select[name="Job-Level-Seniority"]').val();
					if (jobLevelSeniority === '') {
						e.preventDefault();
					}
					var jobFunction = $('select[name="Job-Function"]').val();
					if (jobFunction === '') {
						e.preventDefault();
					}
				}
				
			});
        }
    });

} )( jQuery );
